import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/report',
    name: 'Report',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'mdi-chart-line',
      alwaysShow: true
    },
    children: [
      {
        path: 'platform',
        name: 'ReportPlatform',
        component: () => import('@/views/Admin/Report/Platform.vue'),
        meta: { title: '平台报表', icon: 'mdi-chart-box-outline' }
      },
      {
        path: 'shop',
        name: 'ReportShop',
        component: () => import('@/views/Admin/Report/Shop.vue'),
        meta: { title: '商品报表', icon: 'mdi-file-chart' }
      },
      {
        path: 'finance',
        name: 'ReportFinanceDaily',
        component: () => import('@/views/Admin/Report/FinanceDaily.vue'),
        meta: { title: '财务报表', icon: 'mdi-finance' }
      },
      {
        path: 'vip',
        name: 'ReportVip',
        component: () => import('@/views/Admin/Report/Vip.vue'),
        meta: { title: 'VIP报表', icon: 'mdi-crown-outline' }
      },
      {
        path: 'coupon',
        name: 'ReportCoupon',
        component: () => import('@/views/Admin/Report/Coupon.vue'),
        meta: { title: '优惠券报表', icon: 'mdi-ticket-percent-outline' }
      },
      {
        path: 'ticket',
        name: 'ReportTicket',
        component: () => import('@/views/Admin/Report/Ticket.vue'),
        meta: { title: '挑战卡报表', icon: 'mdi-card-account-details-outline' }
      },
      {
        path: 'shop-daily',
        name: 'ReportShopDaily',
        component: () => import('@/views/Admin/Report/ShopDaily.vue'),
        meta: { title: '商品日报表', icon: 'mdi-file-chart-outline', hidden: true }
      },
      {
        path: 'dealer',
        name: 'ReportDealer',
        component: () => import('@/views/Admin/Report/Dealer.vue'),
        meta: { title: '分销报表', hidden: true }
      },
      {
        path: 'dealer-daily',
        name: 'ReportDealerDaily',
        component: () => import('@/views/Admin/Report/DealerDaily.vue'),
        meta: { title: '分销日报', hidden: true }
      }
    ]
  }
]

export default reportRoutes
